export const isWifiConnection = (connectionType) =>
  String(connectionType || "").toLowerCase() === "wifi";

export const isTempStateOn = (sensor) => {
  const v = sensor?.temp_state;
  return v === 1 || v === true || v === "1";
};

/** Overheat / T!: WiFi uses temp_state; TCP/IP and Modbus keep threshold vs live IR temp. */
export const isSensorOverheat = (sensor, _irTempIds = [], connectionType = "") => {
  if (isWifiConnection(connectionType)) return isTempStateOn(sensor);
  const threshold = Number(sensor?.threshold_value || sensor?.ir_alarm_set_temp || 0);
  if (!(threshold > 0)) return false;
  const temp = Number(sensor?.ir_temperature || 0);
  return Number.isFinite(temp) && temp > threshold;
};
